import { useState, type FormEvent } from "react";
import { Alert, Button, Card, CardBody, Field, Input } from "@fellowflats/ui";
import { supabase } from "../lib/supabase";
import { Brand } from "../components/brand";

/** Email and password. The 6-digit code comes next (factor.tsx). */
export function SignIn() {
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = new FormData(e.currentTarget);
    setBusy(true);
    setError(null);
    const { error } = await supabase.auth.signInWithPassword({ email: String(form.get("email")), password: String(form.get("password")) });
    setBusy(false);
    if (error) setError(error.message);
  }

  return (
    <main className="flex min-h-screen items-center justify-center bg-muted px-4">
      <Card className="w-full max-w-sm">
        <CardBody className="space-y-5 p-6">
          <Brand />
          <form onSubmit={submit} className="space-y-4">
            <Field label="Email" htmlFor="email">
              <Input id="email" name="email" type="email" autoComplete="username" required />
            </Field>
            <Field label="Password" htmlFor="password">
              <Input id="password" name="password" type="password" autoComplete="current-password" required />
            </Field>
            {error && <Alert>{error}</Alert>}
            <Button type="submit" fullWidth loading={busy}>
              Sign in
            </Button>
          </form>
          <p className="text-xs text-muted-foreground">Staff only. You will be asked for a 6-digit code from your authenticator app.</p>
        </CardBody>
      </Card>
    </main>
  );
}
